module.exports = __webpack_public_path__ + "img/system31-details.a7cad46c.png";